import Box from '@mui/material/Box';
import type { FC } from 'react';
import type { FollowUpConfigDraft } from 'services/types/followUpConfig';

import BasicInformationSection from './components/BasicInformationSection';
import ConditionsAndComponentsSection from './components/ConditionsAndComponentsSection';
import ConfigurationSection from './components/ConfigurationSection';
import MessageContentSection from './components/MessageContentSection';
import SendingConfigurationSection from './components/SendingConfigurationSection';
import SurveyConfigurationSection from './components/SurveyConfigurationSection';
import TemplatesSection from './components/TemplatesSection';

interface FollowUpConfigFormAttributesProps {
  followUpConfigDraft: FollowUpConfigDraft;
  isEditing: boolean;
  setFollowUpConfigDraft?: (followUpConfigDraft: FollowUpConfigDraft) => void;
  isCampaign?: boolean;
  businessUnitId?: number;
  hideVisibleFields?: boolean; // Hide fields that are already visible in table row
  hideSurveyConfig?: boolean; // Hide survey config (when rendered separately by the parent)
  hideIdentifier?: boolean; // Hide the identifier field (when set elsewhere by the parent)
}

const FollowUpConfigFormAttributes: FC<FollowUpConfigFormAttributesProps> = ({
  followUpConfigDraft,
  isEditing,
  setFollowUpConfigDraft = undefined,
  isCampaign = false,
  businessUnitId = undefined,
  hideVisibleFields = false,
  hideSurveyConfig = false,
  hideIdentifier = false,
}) => {
  return (
    <Box>
      {!hideVisibleFields && (
        <BasicInformationSection
          followUpConfigDraft={followUpConfigDraft}
          isEditing={isEditing}
          setFollowUpConfigDraft={setFollowUpConfigDraft}
          hideIdentifier={hideIdentifier}
        />
      )}

      <MessageContentSection
        followUpConfigDraft={followUpConfigDraft}
        isEditing={isEditing}
        setFollowUpConfigDraft={setFollowUpConfigDraft}
      />

      <TemplatesSection
        followUpConfigDraft={followUpConfigDraft}
        isEditing={isEditing}
        isCampaign={isCampaign}
        businessUnitId={businessUnitId}
        setFollowUpConfigDraft={setFollowUpConfigDraft}
      />

      {(!hideVisibleFields || isEditing) && (
        <SendingConfigurationSection
          followUpConfigDraft={followUpConfigDraft}
          isEditing={isEditing}
          setFollowUpConfigDraft={setFollowUpConfigDraft}
        />
      )}

      <ConfigurationSection
        followUpConfigDraft={followUpConfigDraft}
        isEditing={isEditing}
        setFollowUpConfigDraft={setFollowUpConfigDraft}
      />

      <ConditionsAndComponentsSection
        followUpConfigDraft={followUpConfigDraft}
        isEditing={isEditing}
        setFollowUpConfigDraft={setFollowUpConfigDraft}
      />

      {!hideSurveyConfig && (
        <SurveyConfigurationSection
          followUpConfigDraft={followUpConfigDraft}
          isEditing={isEditing}
          setFollowUpConfigDraft={setFollowUpConfigDraft}
        />
      )}
    </Box>
  );
};

export default FollowUpConfigFormAttributes;
